module.exports = __webpack_public_path__ + "static/media/generalItemSheet.5d681f1f.xlsx";